/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import zip from 'lodash/zip';
import map from 'lodash/map';
import { injectIntl } from 'react-intl';
import IntlMsg from 'lorautils/intl/IntlMsg';
import { transform, getCenterAndZoom } from 'lorautils/map';
import imgConnected from '../../images/green.svg';

const defaultProps = {
  onZoom: () => {},
  onDrag: () => {},
};

const propTypes = {
  devices: PropTypes.array.isRequired,
  dashId: PropTypes.string.isRequired,
  intl: PropTypes.any.isRequired,
  onZoom: PropTypes.func,
  onDrag: PropTypes.func,
};


class MapMask extends React.Component {

  constructor(props) {
    super(props);
    this.markers = [];
    this.listeners = [];
    this.devices = props.devices;
    this.intlMsg = new IntlMsg(props.intl, 'devicedetail.map');
  }

  componentDidMount() {
    let tries = 0;
    const init = () => {
      try {
        this.initMap();
        this.updateData();
      } catch (e) {
        if (tries < 10) {
          tries += 1;
          setTimeout(init, 1000);
        }
      }
    };
    init();
  }

  componentWillReceiveProps(nextProps) {
    const { devices } = nextProps;
    if (devices !== this.props.devices) {
      this.devices = devices;
      if (this.map) {
        this.map.clearOverlays();
        this.updateData();
      }
    }
  }

  componentWillUnmount() {
    map(zip(this.markers, this.listeners), ([marker, listener]) => {
      marker.removeEventListener('click', listener);
    });
    $('#devicemap').empty();
  }

  initMap() {
    this.map = new BMap.Map(this.props.dashId);
    this.map.setMapStyle({ features: [] });
    this.map.setMaxZoom(16);
    this.map.setMinZoom(2);
    this.map.enableScrollWheelZoom();
    this.map.removeControl(this.navControl);
    this.map.removeControl(this.scaleControl);
    // eslint-disable-next-line
    this.navControl = new BMap.NavigationControl({ anchor: BMAP_ANCHOR_BOTTOM_RIGHT });
    // eslint-disable-next-line
    this.scaleControl = new BMap.ScaleControl({ anchor: BMAP_ANCHOR_BOTTOM_RIGHT });

    this.map.addControl(this.navControl);
    this.map.addControl(this.scaleControl);
    this.map.addEventListener('zoomend', () => this.props.onZoom(this.map));
    this.map.addEventListener('dragend', () => this.props.onDrag(this.map));
  }

  updateData() {
    this.devices = transform(this.devices);
    this.devices.forEach((obj) => {
      this.addMarker(obj);
    });

    const points = this.devices.map(x => x.point);
    if (points.length === 1) {
      this.map.centerAndZoom(points[0], 16);
    } else if (points.length > 0) {
      // decide max span with at most 100 points
      const [center, zoom] = getCenterAndZoom(points.slice(0, 100));
      this.map.centerAndZoom(center, zoom);
    } else {
      this.map.centerAndZoom('深圳', 1);
    }
  }

  addMarker(item) {
    const icon = new BMap.Icon(imgConnected, new BMap.Size(20, 20));
    const marker = new BMap.Marker(item.point, { icon });
    this.map.addOverlay(marker);
    this.markers.push(marker);
  }

  render() {
    return <div id={this.props.dashId} style={{ height: '100%', width: '100%' }} />;
  }
}


MapMask.defaultProps = defaultProps;
MapMask.propTypes = propTypes;

const mapDispatchToProps = {
  pushState: routerActions.push,
};

export default connect(null, mapDispatchToProps)(injectIntl(MapMask));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/DashBoardView/coms/MaskMap/index.jsx